import { Component, NgModule } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <footer class="h-100"><ng-content></ng-content></footer>
  `,
  styleUrls: ['./footer.component.scss'],
  standalone: false
})

export class FooterComponent {

}

@NgModule({
  declarations: [ FooterComponent ],
  exports: [ FooterComponent ]
})
export class FooterModule { }
